export default "__VITE_ASSET__JdCtDpq$OGYzqvf4SjnvWA__"